import { render } from "./CircleLoader.vue?vue&type=template&id=70118f08&scoped=true"
import script from "./CircleLoader.vue?vue&type=script&lang=js"
export * from "./CircleLoader.vue?vue&type=script&lang=js"

import "./CircleLoader.vue?vue&type=style&index=0&id=70118f08&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-70118f08"

export default script